(function() { window.GUID_634524a5_41ef_4596_9bf0_8501f0277f8b = { getGuid: function() { return "634524a5-41ef-4596-9bf0-8501f0277f8b"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PlayerSearchFilter;
        (function (PlayerSearchFilter) {
            PlayerSearchFilter[PlayerSearchFilter["Name"] = 0] = "Name";
            PlayerSearchFilter[PlayerSearchFilter["Event"] = 1] = "Event";
            PlayerSearchFilter[PlayerSearchFilter["Association"] = 2] = "Association";
            PlayerSearchFilter[PlayerSearchFilter["Operator"] = 3] = "Operator";
            PlayerSearchFilter[PlayerSearchFilter["Location"] = 4] = "Location";
            PlayerSearchFilter[PlayerSearchFilter["HomeBar"] = 5] = "HomeBar";
            PlayerSearchFilter[PlayerSearchFilter["CSR"] = 6] = "CSR";
        })(PlayerSearchFilter = Enumeration.PlayerSearchFilter || (Enumeration.PlayerSearchFilter = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PlayerSearchFilter.pre.js.map
